import DirectTag from './DirectTag'
import ExpressTag from './ExpressTag'
import LegacyTag from './LegacyTag'
import HelpTag from './HelpTag'
import StatusTag from './StatusTag'
import TrackingTag from './TrackingTag'
import LinkTag from './LinkTag'
import RedirectRequestInfoTag from './RedirectRequestInfoTag'

export default {
  DirectTag,
  ExpressTag,
  LegacyTag,
  HelpTag,
  StatusTag,
  TrackingTag,
  LinkTag,
  RedirectRequestInfoTag
}
